export const EPublicI9Status = {
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  SECTION_1_COMPLETED: "SECTION_1_COMPLETED",
  AUTHORIZED_REPRESENTATIVE_CONTACTED: "AUTHORIZED_REPRESENTATIVE_CONTACTED",
  SECTION_2_COMPLETED: "SECTION_2_COMPLETED",
  SUPPLEMENT_B_COMPLETED: "SUPPLEMENT_B_COMPLETED",
} as const;

export type TPublicI9Status = keyof typeof EPublicI9Status;
